import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { RootState } from '../../redux/reducers/rootReducer';
import { IMainPage } from '../../utils/types/state-types';
import ArrowRightIconV2 from '../SVGIcons/ArrowRightIconV2';
import classes from './main-idae-block.module.scss';

function MainIdeaBlock() {
  const mainPage = useSelector<RootState, IMainPage | null>(
    (state) => state.mainReducer.mainPage,
  );

  return mainPage?.braveIdeasShow ? (
    <div className={classes.container}>
      <div className={classes.ideaHeader}>
        <h2>
          {mainPage?.braveIdeasTitle
            || 'В Купере смелые идеи связаны с нацеленностью на результат'}
        </h2>
      </div>
      <div className={classes.ideaContent}>
        <p>
          {mainPage?.braveIdeasDescription
            || 'Наш фокус — скорость с ориентацией на качество. Мы развиваем технологии и применяем data-driven подход'}
        </p>
        <Link to="/catalog-vacancies" className={classes.vacancies}>
          {mainPage?.braveIdeasButtonText || 'Смотреть вакансии'}
          {' '}
          <ArrowRightIconV2 fill="white" />
        </Link>
      </div>
    </div>
  ) : null;
}

export default MainIdeaBlock;
